// eslint-disable-next-line no-restricted-imports
import { PositionInCompanyFragment } from 'api/generated/graphql';
import { parseFileDocumentEntity } from 'api/helpers/client/parseEntity/parseFileEntity';
import { HeadPositionEntity } from 'api/types/entity';
import { lodash } from 'helpers';

export const parsePositionInCompanyEntity = (
  positionInCompany: PositionInCompanyFragment
): HeadPositionEntity => ({
  position: positionInCompany.positionInCompany,
  files: lodash
    .compact(positionInCompany.positionConfirmationDocuments)
    .map(parseFileDocumentEntity),
  expirationDate: positionInCompany.expirationDate
    ? new Date(positionInCompany.expirationDate)
    : undefined,
});
